<template>
  <div class="home">
    <div id="siteMaps" :style="'height:'+ heights +'px'"></div>
  </div>
</template>

<script>
import { initBMap, initGoogleMap,initBMapTest } from "@/js/mapGetterAddress";
import RsaCrypto from "@/js/crypto";
export default {
  name: 'Home',
  components: {},
  data(){
    return {
      // map: null,
      heights:500,
      longitude: "", //经度-用于搜索
      latitude: "", //纬度-用于搜索
      location:"",//地址
      lon:"",
      lat:"",
      center:[]
    }
  },
  methods:{
    isGoogle(){
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDtiVDTtym3jwAYgr1QSdytMw8ZbFferng&language=en";
      document.getElementsByTagName('head')[0].appendChild(script);
    },
  },
  mounted(){
    var query = this.$route.query;
    this.heights = window.innerHeight;
    if(query.hasOwnProperty('type')&&query.hasOwnProperty('lon')&&query.hasOwnProperty('lat')){
      this.center.push(parseFloat(query.lon))
      this.center.push(parseFloat(query.lat))
      this.lon = query.lon
      this.lat = query.lat
      console.log('query.type',query.type)
      if(query.type=='Google'){
        this.isGoogle();
        setTimeout(() => {
            initGoogleMap(this);
          }, 500);
      }else if(query.type=='BaiduTest'){
        console.log('BaiduTest')
        this.$nextTick(()=>{
          initBMapTest(this);
        })
      } else{
        this.$nextTick(()=>{
          initBMap(this);
        })
      }
    }
  }
}
</script>

<style >
*{
  padding: 0px;
  margin: 0px;
}
#siteMaps{
  width: 100%;

}
</style>
